/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Subscriptions_CountInputs */

const en_admin_subscriptions_count = /** @type {(inputs: Admin_Subscriptions_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} subscriptions`)
};

const zh_admin_subscriptions_count = /** @type {(inputs: Admin_Subscriptions_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`共 ${i?.count} 条`)
};

/**
* | output |
* | --- |
* | "{count} subscriptions" |
*
* @param {Admin_Subscriptions_CountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_subscriptions_count = /** @type {((inputs: Admin_Subscriptions_CountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscriptions_CountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_subscriptions_count(inputs)
	return zh_admin_subscriptions_count(inputs)
});
export { admin_subscriptions_count as "admin.subscriptions.count" }